define( function() {
	return ( /\?/ );
} );



/*****************
 ** WEBPACK FOOTER
 ** F:/actions-runner/_work/scpbuildinig_sentience.portal.devops/scpbuildinig_sentience.portal.devops/src/Production/Portal/Cloud.Platform.Global.Portal.DevOps.Web/~/jquery/src/ajax/var/rquery.js
 ** module id = 888
 ** module chunks = 2
 **/